var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/ugc-tile-macro.j2"] = require( "macros/ugc-tile-macro.j2" );
dependencies["contentful/ugc-filters.j2"] = require( "contentful/ugc-filters.j2" );
dependencies["contentful/ugc-tray.j2"] = require( "contentful/ugc-tray.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/ugc-module-content.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/ugc-tile-macro.j2", false, "core/templates/contentful/ugc-module-content.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayUgcTile")) {
var t_4 = t_1.displayUgcTile;
} else {
cb(new Error("cannot import 'displayUgcTile'")); return;
}
context.setVariable("displayUgcTile", t_4);
output += "\n\n<div class=\"dom-ugc js-ugc\" data-qa-ugc=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "multipleIndex"), env.opts.autoescape);
output += "\" data-index=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "multipleIndex"), env.opts.autoescape);
output += "\">\n\n    ";
var t_5;
t_5 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ugc")),"displayHearts");
frame.set("displayHearts", t_5, true);
if(frame.topLevel) {
context.setVariable("displayHearts", t_5);
}
if(frame.topLevel) {
context.addExport("displayHearts", t_5);
}
output += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "category")) {
output += "\n        ";
var t_6;
t_6 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug");
frame.set("navigationId", t_6, true);
if(frame.topLevel) {
context.setVariable("navigationId", t_6);
}
if(frame.topLevel) {
context.addExport("navigationId", t_6);
}
output += "\n    ";
;
}
else {
output += "\n        ";
var t_7;
t_7 = "";
frame.set("navigationId", t_7, true);
if(frame.topLevel) {
context.setVariable("navigationId", t_7);
}
if(frame.topLevel) {
context.addExport("navigationId", t_7);
}
output += "\n    ";
;
}
output += "\n\n    ";
env.getTemplate("contentful/ugc-filters.j2", false, "core/templates/contentful/ugc-module-content.j2", null, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
t_8.render(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
output += t_9
output += "\n\n    <div class=\"o-row c-ugc__content\">";
frame = frame.push();
var t_14 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ugc")),"items");
if(t_14) {var t_13 = t_14.length;
for(var t_12=0; t_12 < t_14.length; t_12++) {
var t_15 = t_14[t_12];
frame.set("item", t_15);
frame.set("loop.index", t_12 + 1);
frame.set("loop.index0", t_12);
frame.set("loop.revindex", t_13 - t_12);
frame.set("loop.revindex0", t_13 - t_12 - 1);
frame.set("loop.first", t_12 === 0);
frame.set("loop.last", t_12 === t_13 - 1);
frame.set("loop.length", t_13);
output += "\n\n            ";
output += "\n            ";
if((lineno = 18, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["ugc.tray.clickedTileIndex",-1])) == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index")) {
output += "\n\n                ";
var t_16;
t_16 = true;
frame.set("isClickedTile", t_16, true);
if(frame.topLevel) {
context.setVariable("isClickedTile", t_16);
}
if(frame.topLevel) {
context.addExport("isClickedTile", t_16);
}
output += "\n\n            ";
;
}
else {
output += "\n\n                ";
var t_17;
t_17 = false;
frame.set("isClickedTile", t_17, true);
if(frame.topLevel) {
context.setVariable("isClickedTile", t_17);
}
if(frame.topLevel) {
context.addExport("isClickedTile", t_17);
}
output += "\n\n            ";
;
}
output += "\n            ";
output += runtime.suppressValue((lineno = 29, colno = 27, runtime.callWrap(t_4, "displayUgcTile", context, [t_15,runtime.makeKeywordArgs({"tileTemplate": "TILE_WITH_HOVER","index": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"),"isClickedTile": runtime.contextOrFrameLookup(context, frame, "isClickedTile"),"displayHearts": runtime.contextOrFrameLookup(context, frame, "displayHearts"),"navigationId": runtime.contextOrFrameLookup(context, frame, "navigationId")})])), env.opts.autoescape);
output += "\n\n            ";
output += "\n            ";
if((lineno = 32, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["ugc.tray.trayTileIndex",-1])) == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index")) {
output += "\n\n                ";
env.getTemplate("contentful/ugc-tray.j2", false, "core/templates/contentful/ugc-module-content.j2", null, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
t_18.render(context.getVariables(), frame, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
output += t_19
output += "\n\n            ";
})});
}
;
}
}
frame = frame.pop();
output += "</div>\n\n    ";
if((lineno = 42, colno = 12, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["ugc.seeMore"]))) {
output += "\n\n        <div class=\"o-row\">\n\n            <div class=\"g-ugc__see-more\">\n\n                <button class=\"c-ugc__see-more js-ugc-see-more\" type=\"submit\"\n                    data-qa-ugc-see-more\n                    ";
output += runtime.suppressValue((lineno = 50, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","ugc","See More"])), env.opts.autoescape);
output += ">\n\n                    ";
output += runtime.suppressValue((lineno = 52, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["ugc_see-more-link"])), env.opts.autoescape);
output += "\n\n                </button>\n\n            </div>\n\n        </div>\n\n    ";
;
}
output += "</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/ugc-module-content.j2"] , dependencies)